import CountLabel from './CountLabel';
import countLabelStyles from './countLabel.module.scss';

export { CountLabel, countLabelStyles };

export default CountLabel;
